import React from 'react';
import _ from 'lodash';
import moment from 'moment';

import CommentForm from './CommentForm';
import CommentStore from '../../stores/CommentStore';
import LoginSession from '../../stores/LoginSession';

const CommentList = (props) => {
  const renderComment = (comment_wph, index) => {
    const comment_text = comment_wph.attributes.comment || comment_wph.attributes.note_text;
    const executor_name = comment_wph.attributes.executor.attributes.full_name;

    const [created_at_date, created_at_time] = comment_wph.attributes.created_at.split(" ");

    moment.locale('th');
    const created_at = `${created_at_date} เวลา ${created_at_time}`

    const state_name = _.find(props.workflow_states, {id: comment_wph.attributes.workflow_state.id}).attributes.state_name;
    const action_name = _.find(props.workflow_state_actions, {id: comment_wph.attributes.workflow_state_action.id}).attributes.action_name;

    return(
      <div className="card mb-3" key={"comment_list_" + index}>
        <div className="card-header">
          <strong>{action_name}</strong>
          <span className="ml-1 text-muted">{"โดย" + executor_name + " เมื่อ " + created_at}</span>
        </div>
        <div className="card-body">
          <p className="card-text">{comment_text}</p>
        </div>
      </div>
    )
  }

  const handleDeleteComment = (comment) => {
    if (!window.confirm('ยืนยันการลบ')) { return }
    CommentStore.request({
      id: comment.id,
      method: 'delete'
    }).then(()=>{
      props.onReloadWorkflowProcess(props.workflow_process_id);
    })
  }

  const renderCommentList = (comment, index) => {
    const comment_text = _.get(comment, 'attributes.content', '');
    const comment_by_user_name = _.get(comment, 'attributes.comment_by_info.full_name', '');
    const created_at = _.get(comment, 'attributes.created_at', '');
    const action_name = _.get(comment, 'attributes.action_name', '');
    return (
      <div className="card mb-3" key={"comment_list_" + index}>
        <div className="card-header">
          <span className="ml-1 text-muted">{"โดย" + comment_by_user_name}</span>
          
          {!_.isEmpty(action_name) && (
            <span className="ml-1 text-danger">{"(" + action_name + ")" }</span>
          )}

          <span className="ml-1 text-muted">{"เมื่อ " + created_at}</span>

          {(_.get(comment, 'attributes.comment_by.id') === LoginSession.current.user.id) && (
            <i className="fa fa-trash-o pointer text-danger ml-3 force-right" aria-hidden="true" onClick={() => handleDeleteComment(comment)}></i>
          )}
        </div>
        <div className="card-body">
          <p className="card-text">{comment_text}</p>
          <div>
            {!_.isEmpty(comment.attributes.comment_files) && _.map(comment.attributes.comment_files, renderFile)}
          </div>
        </div>
      </div>
    )
  }

  const renderFile = (comment_file, index) => {
    const file = _.find(props.comment_files, {id: comment_file.id});
    if (_.isEmpty(file)){ return }
    return (
      <div key={`comment_file_key_${index}`}>
        <a href={file.attributes.url} target="_blank">
          {file.attributes.attachment_file_name}
        </a>
      </div>
    )
  }

  return(
    <div>
        <div className="form-group">
          {props.comments.map((comment, index) => (renderCommentList(comment, index)))}
        </div>

        <CommentForm {...props} />
      </div>
  )
}

export default CommentList;


// WEBPACK FOOTER //
// ./src/components/WorkflowActions/CommentList.js